import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { createWorkEnvironmentSurvey } from '../../api/workEnvironmentQueries';
import { CreateWorkEnvironmentSurveyRequest } from '../../api/workEnvironmentTypes';
import { WorkEnvironmentSurveysByTeamIdQueryKey } from '../queries/useGetWorkEnvironmentSurveysByTeamIdQuery';
import { invitationLaterText } from '../../pages/WorkEnvironmentSurveyDetail/reminderView';

type UseCreateWorkEnvironmentSurveyMutationOptions = {
  onSuccess?: (response: any) => void;
  onError?: (error: Error) => void;
};

export const useCreateWorkEnvironmentSurveyMutation = (
  teamId: number,
  options?: UseCreateWorkEnvironmentSurveyMutationOptions,
) => {
  const queryClient = useQueryClient();
  const { t, i18n } = useTranslation();

  return useMutation({
    mutationFn: (surveyForm: CreateWorkEnvironmentSurveyRequest) =>
      createWorkEnvironmentSurvey(surveyForm),
    onSuccess: (response) => {
      // Outside the working hours of the team, «Send now» waits for them, so the user is told when the team gets it
      const later = invitationLaterText(response?.invitationSendsAt, t, i18n.language);
      if (later) toast.info(later, { autoClose: 8000 });

      // Invalidate queries
      queryClient.invalidateQueries({
        queryKey: [WorkEnvironmentSurveysByTeamIdQueryKey, teamId],
      });

      // Call custom onSuccess callback if provided
      options?.onSuccess?.(response);
    },
    onError: options?.onError,
  });
};